export enum HomeInsuranceCode {
    Cottage = 'GYVNAM_K',
    Apartment = 'BUT',
    House = 'GYVNAM',
    TotalArea = 'PLOTAS',
    ConstructionYear = 'STATM',
}
